import * as React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Cancel from "@mui/icons-material/Cancel";
import {styled, alpha} from "@mui/material/styles";



const ChipBox = styled(Box)(({theme}) => ({
    borderRadius: 16,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '4px 8px',
    backgroundColor: theme.palette.action.selected,
    color: theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightMedium,
    cursor: 'default',
    // '&:hover': {
    //     backgroundColor: theme.palette.action.hover, // Hover effect
    // },
    '& .MuiIconButton-root': {
        padding: '2px',
        marginLeft: theme.spacing(0.5),
        color: alpha(theme.palette.text.primary, 0.3),
        '&:hover': {
            color: alpha(theme.palette.text.primary, 0.5),
        },
    },
}));

interface IProps {
    children: React.ReactNode;
    onDelete: () => void;
}

const SelectChip: React.FC<IProps> = ({children, onDelete, ...otherProps}) => {
    return (
        <ChipBox {...otherProps}>
            {children}
            <IconButton aria-label="cancel" onClick={onDelete} color="inherit">
                <Cancel fontSize="small"/>
            </IconButton>
        </ChipBox>
    )
}

export default SelectChip;
